import React, { useState } from "react";
import backgroundSvg from "../svgs/background.svg";
import { CogIcon } from "@heroicons/react/outline";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { useEffect } from "react";


const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    marginLeft: -30,
  },
}))(Tooltip);



function Navbar() {
  // const [active, setActive] = useState(false);
  const [open, setOpen] = useState(false);
  const [navAnimate, setNavAnimate] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll",animateNav)
    return () => window.removeEventListener("scroll", animateNav)
  },[])

  function animateNav(){
    if(window.scrollY > 670){
      setNavAnimate(true);
    }
    else{
      setNavAnimate(false);
    }
  }
  
  return (
    <div className={`flex items-center justify-evenly w-screen pt-5 pb-5 transition duration-200 top-0 fixed nav__zindex opacity-0 ${navAnimate && "bg-[#222222b7] opacity-100"} `}>
    {/* <div className={`flex items-center justify-evenly w-screen pt-5 pb-5 mt-10  transition duration-200 fixed top-0 nav__zindex ${navAnimate && "bg-[#222222b7] "} `}>  */}
      <div className="text-white relative">
        <p className="flex flex-nowrap text-xs sm:text-base sm:-ml-10">
          {" "}
          <span className={open ? "hidden sm:flex text-blue-400 font-semibold" : "hidden sm:flex"  }>Frontend</span>{" "}
          <span className="px-1 navbar__sawan">Sawan</span>
        </p>
        <img
          src={backgroundSvg}
          alt=""
          className=" h-20  sm:h-20 absolute -top-7 opacity-70 left-0 sm:left-7 "
        />
      </div>
      {open ? (
           <div className="flex items-center text-xs sm:text-base -ml-6 sm:-ml-20 text-blue-400">
          <p className="ml-7 cursor-pointer bg-[rgba(94,107,167,0.15)] p-2 rounded-md"> <a href=""> About</a></p>
          <p className="ml-4 sm:ml-7 opacity-80 cursor-pointer hover:opacity-100 bg-[rgba(94,107,167,0.15)] p-2 rounded-md">
            Services
          </p>
          <p className="ml-4 sm:ml-7 opacity-80 cursor-pointer hover:opacity-100 bg-[rgba(94,107,167,0.15)] p-2 rounded-md">
            Contact
          </p>
        </div>
      ) : (
          <div className="flex items-center text-xs sm:text-base -ml-6 sm:-ml-20">
        <p className="pl-7  cursor-pointer"> <a href="#about">About</a> </p>
        {/* <p className="pl-4 sm:pl-7 opacity-80 cursor-pointer hover:opacity-100">Work</p> */}
        <p className="pl-4 sm:pl-7 opacity-80 cursor-pointer hover:opacity-100">
        <a href="#service"> Services</a> 
        </p>
        <p className="pl-4 sm:pl-7 opacity-80 cursor-pointer hover:opacity-100">
         <a href="#contact"> Contact </a>
        </p>
      </div>
      )}
      <div className="relative">
        <LightTooltip title="Don't like menu! Click on it😉">
        <button
          className=" group h-10 focus:outline-none w-10 p-1 sm:rounded-xl text-white
          sm:bg-[rgba(255,255,255,0.10)] transition duration-200  sm:text-base opacity-80 hover:opacity-100"
        >
          
          {/* <CogIcon
            className={open ? "animate-spin group-hover:animate-bounce text-blue-400" : "animate-spin group-hover:animate-bounce" }
            onClick={() => setOpen(!open)}
          /> */}
        </button>
        </LightTooltip>
      </div>

      {/* <div className="relative">
        {open && (
          <div className="absolute right-36 top-6 bg-white w-40 h-40 bg-[rgba(255,255,255,0.16)] rounded-md">
            <div className="flex flex-col items-center pt-5 text-sm cursor-pointer">
              <p className="border-b border-gray-600 w-full flex justify-center pb-3 ">
                Change Profile
              </p>
              <p className="border-b border-gray-600 w-full flex justify-center pb-3 pt-5 cursor-pointer">
                Change Theme
              </p>

              <p className=" w-full flex justify-center pb-3 pt-5 cursor-pointer">
                Change NoIdea
              </p>
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
}

export default Navbar;
